// extracted by mini-css-extract-plugin
export default {"container":"_10sAHA","details":"_3awnHr","wiproSupport":"_1zYh7h","title":"_3F6YIf","id":"_2rbZ-E"};